import { Component } from '@angular/core';
import {ParamBaseComponent} from "../../../../bases/param-base-component";
import {ComponentType} from "@angular/cdk/overlay";
import {MetricsDimensionsPickerComponent} from "../../../metrics-dimensions-picker/metrics-dimensions-picker.component";
import {Observable} from 'rxjs';
import {MetricComponentObject} from '../../../../classes/metric-component-object';
import {selectMetricComponentObjects, selectMetricSourceGroups} from '../../../../store/selectors';
import {selectDataSetMetricsGroupComponentObjects} from '../../../../store/dataSetMetricsGroups/dataSetMetricsGroups.selectors';
import {DatasetMetricsGroupComponentObjects} from '../../../../classes/dataset-metrics-group-component-object';

@Component({
  selector: 'app-param-metrics',
  templateUrl: './report-param-metrics.component.html',
  styleUrls: ['./report-param-metrics.component.scss']
})
export class ReportParamMetricsComponent extends ParamBaseComponent {
  public readonly component: ComponentType<MetricsDimensionsPickerComponent> = MetricsDimensionsPickerComponent;

  public readonly options$: Observable<Array<MetricComponentObject>> = this._store.select(this.paramDef.data || selectMetricComponentObjects);
  public readonly categories$: Observable<DatasetMetricsGroupComponentObjects> = this._store.select(selectDataSetMetricsGroupComponentObjects);
  public readonly sources$: Observable<DatasetMetricsGroupComponentObjects> = this._store.select(selectMetricSourceGroups);

}
